<template>
  <app-layout>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-card-title>
              <h1>{{ $t('Mensajes') }}</h1>
            </v-card-title>
            <v-card-text>
              <broadcast-message-table
                entity="broadcast-messages"
                :level="1"
                search-input
                default-icon="mdi-document"
              ></broadcast-message-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import BroadcastMessageTable from '../components/BroadcastMessageTable.vue';
export default {
  components: {
    AppLayout,
    BroadcastMessageTable,
  },
};
</script>

<style lang="scss" scoped></style>
